import { Fragment } from "react";

import HeaderCartButton from "./HeaderCartButton";
import CategoryTabs from "./CategoryTabs";
import mealsImage from "../../assets/meals.jpg";
import mealsLogo from "../../assets/mealsLogo.png";
import classes from "./Header.module.css";

const Header = ({ onShowCart, activeCategory, onCategoryChange }) => {
  return (
    <Fragment>
      <header className={classes.header}>
        <div className={classes.topRow}>
          <div className={classes.logo}>
            <img className={classes.logoImg} src={mealsLogo} alt="logo!" />
            <div className={classes.brandText}>
              <span className={classes.brandLinePrimary}>Attempt</span>
              <span className={classes.brandLineSecondary}>Treats</span>
            </div>
          </div>
          <HeaderCartButton onClick={onShowCart} />
        </div>
        <div className={classes.tabsRow}>
          <CategoryTabs
            activeCategory={activeCategory}
            onChange={onCategoryChange}
          />
        </div>
      </header>
      <div className={classes["main-image"]}>
        <img src={mealsImage} alt="A table full of delicious food!" />
      </div>
    </Fragment>
  );
};

export default Header;
